<template>
    <b-modal id="complaint_resident" ref="complaint_resident" @hidden="resetModal" no-close-on-backdrop>

        <template v-slot:modal-title>
            <div>
                Resident Complaint
            </div>
        </template>

        <div class="mb-4">
            Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ducimus, neque.
        </div>

        <b-form>
            <b-row>
                <b-colxx md="12">
                    <b-form-group label="Date" class="has-float-label">
                        <template v-slot:label>
                            <span>Date <sup><code>*</code></sup></span>
                        </template>

                        <v-date-picker
                            popover-visibility="focus" mode="single"
                            v-model="datepicker.date"
                            @input="'date' in errors ? delete errors.date : ''"
                            :input-props="{ class:'form-control' + ('date' in errors ? ' border-danger' : ''), placeholder: 'MM-DD-YYYY' }"/>

                        <b-form-invalid-feedback :state="!'date' in errors"
                                                 v-text="'date' in errors ? errors.date[0] : ''"/>
                    </b-form-group>
                </b-colxx>

                <b-colxx md="12">
                    <b-form-group label="Findings" class="has-float-label">
                        <template v-slot:label>
                            <span>Findings <sup><code>*</code></sup></span>
                        </template>

                        <b-form-textarea rows="3" v-model="form.findings"
                                         :class="{'border-danger': 'findings' in errors}"
                                         @input="'findings' in errors ? (delete errors.findings) : ''"
                                         autocomplete="off" placeholder="Findings"/>

                        <b-form-invalid-feedback :state="!'findings' in errors"
                                                 v-text="'findings' in errors ? errors.findings[0] : ''"/>
                    </b-form-group>
                </b-colxx>

                <b-colxx md="12">
                    <b-form-group label="Action Taken" class="has-float-label">
                        <template v-slot:label>
                            <span>Action Taken <sup><code>*</code></sup></span>
                        </template>

                        <b-form-textarea rows="3" v-model="form.action_taken"
                                         :class="{'border-danger': 'action_taken' in errors}"
                                         @input="'action_taken' in errors ? (delete errors.action_taken) : ''"
                                         autocomplete="off" placeholder="Action Taken"/>

                        <b-form-invalid-feedback :state="!'action_taken' in errors"
                                                 v-text="'action_taken' in errors ? errors.action_taken[0] : ''"/>
                    </b-form-group>
                </b-colxx>

                <b-colxx md="12">
                    <b-form-group label="Copy" class="has-float-label">
                        <template v-slot:label>
                            <span>Copy <sup><code>*</code></sup></span>
                        </template>

                        <b-form-textarea rows="3" v-model="form.copy"
                                         :class="{'border-danger': 'copy' in errors}"
                                         @input="'copy' in errors ? (delete errors.copy) : ''"
                                         autocomplete="off" placeholder="Copy"/>

                        <b-form-invalid-feedback :state="!'copy' in errors"
                                                 v-text="'copy' in errors ? errors.copy[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>
        </b-form>

        <template slot="modal-footer">
            <b-button size="sm" variant="secondary" @click="hideModal('complaint_resident')" v-text="'Cancel'"/>

            <state-button size="sm" variant="primary" :click="submitComplaintResident">Submit</state-button>
        </template>
    </b-modal>
</template>

<script>
import StateButton from "../../../../../components/Common/StateButton";
import {mapGetters} from "vuex";
import moment from "moment";

export default {
    name: "ResidentFormModal",

    components: {
        StateButton,
    },

    props: [
        'complaint'
    ],

    computed: {
        ...mapGetters({
            form: 'getComplaintResidentForm',
            errors: 'getComplaintErrors',
        }),
    },

    data() {
        return {
            datepicker: {
                date: null,
            },
        }
    },

    watch: {
        'datepicker.date'(date) {
            if (moment(date).format('YYYY-MM-DD') === 'Invalid date') return this.form.date = null;
            this.form.date = moment(date).format('YYYY-MM-DD');
        },
    },

    methods: {
        submitComplaintResident() {
            return new Promise((success, fail) => {
                this.$store.dispatch('submitComplaintResident', this.form)
                    .then(response => {
                        setTimeout(() => {
                            success();

                            this.$emit('updated');

                            this.$notify('success filled', 'Success!', 'Added resident complaint!', {
                                duration: 4000,
                                permanent: false
                            });

                            this.hideModal('complaint_resident');
                        }, 2000);
                    })
                    .catch(error => {
                        if (error.response.data.error) {
                            this.validationError = error.response.data.error;
                        }

                        setTimeout(() => {
                            fail();
                        }, 1000);
                    });
            })
        },

        resetModal() {
            this.$store.commit('setComplaintResidentForm');

            this.datepicker =  {
                date: null,
            };
        },

        hideModal(refname) {
            this.$refs[refname].hide();
        }
    },
}
</script>

<style scoped>

</style>
